import { FaChartBar, FaEdit } from "react-icons/fa";
import { Link } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ActionButton } from "../../../../../../components/page-releated/grp-standard-screen/actions/actions-button";
import { ITableColumns } from "../../../../../../shared/interfaces/ITable";
import Masks from "../../../../../../shared/utils/mask.utils";
import { Secretary } from "../types/types";

export const secretaryListtableColumns = (
    onEdit: ($: Secretary) => void
): ITableColumns<Secretary>[] => [
    {
        key: "action",
        name: "#",
        dataKey: "id",
        render(_, record) {
            return (
                <div className="flex space-x-3.5">
                    <ActionButton
                        icon={FaEdit}
                        tooltip={{ text: "Editar" }}
                        onClick={() => onEdit(record)}
                    />
                    <OverlayTrigger
                        placement="top"
                        delay={{ show: 250, hide: 400 }}
                        overlay={
                            <Tooltip id="button-tooltip">Projetos</Tooltip>
                        }
                    >
                        <Link
                            to={`secretaria/${record.name}|@|${record.id}`}
                            className="text-teal-600 flex items-center"
                        >
                            <FaChartBar />
                        </Link>
                    </OverlayTrigger>
                </div>
            );
        },
    },
    {
        key: "id",
        name: "Código",
        dataKey: "id",
    },
    {
        key: "name",
        dataKey: "name",
        name: "Nome",
    },
    {
        key: "createdAt",
        dataKey: "createdAt",
        name: "Criado em",
        render: (value) => (value ? Masks.date(value as string) : ""),
    },
    {
        key: "updatedAt",
        dataKey: "updatedAt",
        name: "Atualizado em",
        render: (value) => (value ? Masks.date(value as string) : ""),
    },
];
